import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ContentCollectionView } from "@air/feature-content-collection/redux";
import { MediaQueryProvider } from "@air/provider-media-query";
import { ModalProvider } from "@air/provider-modal";
import { ShortIdProvider } from "@air/provider-short-id";
import { ErrorBoundary } from "@air/utils-error";
import { initialRouterState } from "connected-next-router";
import Router from "next/router";
import { NextSeo } from "next-seo";
import { useMemo } from "react";
import { Provider as ReduxProvider } from "react-redux";
import { BoardCollectionCustomFieldsProvider } from "~/components/BoardCollection/providers/BoardCollectionCustomFieldsProvider";
import { MaintenanceMode } from "~/components/MaintenanceMode/MaintenanceMode";
import { PublicAccountProvider } from "~/providers/AccountProvider";
import { ModifiersKeysPressedProvider } from "~/providers/ModifiersKeysPressedProvider";
import { makeStore } from "~/store";
export const ContentCollectionLayout = (param)=>{
    let { children, data, seo, shortId } = param;
    const { store } = useMemo(()=>{
        return makeStore({
            router: initialRouterState("object" === "undefined" ? undefined : Router.asPath),
            boardCollection: {
                hasSubmitted: false,
                attemptedSubmission: false,
                form: data,
                clips: {},
                shortId,
                view: "onboarding"
            },
            contentCollection: {
                applyAll: true,
                customFields: [],
                form: data,
                shortId,
                touched: false,
                uploadedClips: [],
                view: ContentCollectionView.Onboarding
            }
        });
    }, [
        data,
        shortId
    ]);
    return /*#__PURE__*/ _jsx(MaintenanceMode, {
        children: /*#__PURE__*/ _jsx(ShortIdProvider, {
            shortId: shortId,
            objectId: data.boardId,
            objectType: "board",
            children: /*#__PURE__*/ _jsx(ReduxProvider, {
                store: store,
                children: /*#__PURE__*/ _jsx(ErrorBoundary, {
                    children: /*#__PURE__*/ _jsx(MediaQueryProvider, {
                        children: /*#__PURE__*/ _jsx(PublicAccountProvider, {
                            children: /*#__PURE__*/ _jsx(BoardCollectionCustomFieldsProvider, {
                                children: /*#__PURE__*/ _jsx(ModifiersKeysPressedProvider, {
                                    children: /*#__PURE__*/ _jsxs(ModalProvider, {
                                        children: [
                                            /*#__PURE__*/ _jsx(NextSeo, {
                                                ...seo
                                            }),
                                            children
                                        ]
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};
